import classNames from "classnames";
import React from "react";
import { t } from "ttag";

import { FormTextbox } from "../../../forms/FormTextbox";
import { IReduxFormState } from "../reducers.interfaces";

interface IProps {
    value: string;
    changeFormField: (changedFields: Partial<IReduxFormState>) => void;
    disabled: boolean;
}

interface IState {
    isToggleOn?: boolean;
}

// TODO(ssr, LEVEL 4 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 4/10 due to 94 LOC with accordion state management (toggle visibility), input validation with regex, character length limiting, and form field updates. Moderate complexity with straightforward state.
export class ShippingNotes extends React.Component<IProps, IState> {
    public state: IState = {
        isToggleOn: false,
    };

    render(): React.JSX.Element {
        const noteClasses = classNames({
            "checkout-step__notes--collapsed": !this.state.isToggleOn,
        });

        const arrowClasses = classNames({
            "checkout-step__notes__arrow-right": !this.state.isToggleOn,
            "checkout-step__notes__arrow-down": this.state.isToggleOn,
        });

        const toggleNotesVisibility = (
            event: React.MouseEvent<HTMLAnchorElement>,
        ) => {
            event.preventDefault();
            event.stopPropagation();
            this.setState({
                isToggleOn: !this.state.isToggleOn,
            });
        };

        const setShippingNotes = (
            event: React.FormEvent<HTMLTextAreaElement>,
        ) => {
            // TODO(i18n): Character whitelist regex assumes Latin alphabet; may reject valid characters in other languages (e.g., accented characters, non-Latin scripts)
            const value = event.currentTarget.value.replace(
                /[^a-zA-Z0-9.,!'"() ]/g,
                "",
            );
            if (value.length > 70) {
                return;
            }
            this.props.changeFormField({
                shipping_notes: value,
            });
        };

        return (
            <div>
                <p className="checkout-step__notes-show" id="show-notes">
                    <a
                        className="checkout-step__notes-show--link"
                        href="#"
                        onClick={toggleNotesVisibility}
                        aria-controls="shipping_notes"
                        aria-expanded={this.state.isToggleOn}
                    >
                        <span
                            className={arrowClasses}
                            aria-hidden={true}
                        ></span>
                        {t`Add delivery notes (optional)`}
                    </a>
                </p>
                <div className={noteClasses} id="shipping_notes">
                    <FormTextbox
                        name="shipping_notes"
                        id="shipping_notes_input"
                        label={t`Enter delivery notes...`}
                        labelPlacement="dynamic"
                        maxLength={70}
                        rows={1}
                        cols={50}
                        value={this.props.value}
                        onChange={setShippingNotes}
                        disabled={this.props.disabled}
                        autoComplete="off"
                    />
                </div>
            </div>
        );
    }
}
